import { MIN_DATE } from '../../constants/constants';
import { checkDate, checkDateInterval, checkNotEmpty } from '../../helpers/validators';
export const validateBirthDay = ({ value }) => {
    const minYear = MIN_DATE.split('/').slice(-1);
    const maxDate = new Date().toISOString();
    return (checkNotEmpty({ value, independent: true }) ||
        checkDate({ value }) ||
        checkDateInterval({
            value,
            maxDate,
            message: `Дата рождения должна быть в прошлом, но не раньше ${minYear} года`,
        }));
};
export const validateBirthDayWithMatch = ({ birthdayMatchValidationInfo, ...rest }) => validateBirthDay(rest) || birthdayMatchValidationInfo;
